import { ArticleListItem } from '~/shared/components/Articles/ArticlesList/ArticlesList.types'

import HorisontalArticleItem from './HorisontalArticleItem'

export default function HorisontalArticleGroup({
  articles,
  className = '',
}: {
  articles: ArticleListItem[]
  className?: string
}): React.ReactElement {
  return (
    <div className={`grid grid-cols-3 gap-8 ${className}`}>
      {articles.map(({ _id, slug, ...rest }) => (
        <HorisontalArticleItem key={_id} slug={slug.current} {...rest} />
      ))}
    </div>
  )
}
